import { reportsApi, sourcesApi, usersApi } from "../services";

export const rootMiddleware = [
    usersApi.middleware,
    reportsApi.middleware,
    sourcesApi.middleware,
];
